import React, { useState, useEffect } from 'react';
import './AdModal.css';
import newsImg from '../../assets/images/news/news.jpeg';
import news1Img from '../../assets/images/news/news1.jpeg';
import news2Img from '../../assets/images/news/news2.jpeg';
import news5Img from '../../assets/images/news/news5.jpeg';
import news6Img from '../../assets/images/news/news6.jpeg';
import news7Img from '../../assets/images/news/news7.jpeg';
import citationImg from '../../assets/images/news/citation.jpeg';

const newsImages = [newsImg, news1Img, news2Img, news5Img, news6Img, news7Img, citationImg];

const AdModal: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [currentImage, setCurrentImage] = useState(newsImages[0]);

    useEffect(() => {
        // Select random image when component mounts
        const randomImg = newsImages[Math.floor(Math.random() * newsImages.length)];
        setCurrentImage(randomImg);

        // Show after 30 seconds
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 30000);
        return () => clearTimeout(timer);
    }, []);

    if (!isVisible) return null;

    return (
        <div className="ad-modal-overlay">
            <div className="ad-modal-content">
                <button className="ad-modal-close" onClick={() => setIsVisible(false)}>
                    <i className="fas fa-times"></i>
                </button>
                <div className="ad-image-container">
                    <img src={currentImage} alt="Latest News Advertisement" />
                </div>
            </div>
        </div>
    );
};

export default AdModal;
